import { render, staticRenderFns } from "./SSRAgTable.vue?vue&type=template&id=f1df4884"
import script from "./SSRAgTable.vue?vue&type=script&lang=js"
export * from "./SSRAgTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1df4884')) {
      api.createRecord('f1df4884', component.options)
    } else {
      api.reload('f1df4884', component.options)
    }
    module.hot.accept("./SSRAgTable.vue?vue&type=template&id=f1df4884", function () {
      api.rerender('f1df4884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ag-table/SSRAgTable.vue"
export default component.exports